// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-sortable .ui-sortable-placeholder.visible {
  opacity: 0.2;
}

.ui-sortable .ui-sortable-item {
  cursor: auto;
}
`, "",{"version":3,"sources":["webpack://./lib/ReactViews/Workbench/sortable.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".ui-sortable .ui-sortable-placeholder.visible {\n  opacity: 0.2;\n}\n\n.ui-sortable .ui-sortable-item {\n  cursor: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
